<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Details</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>

  <div class="main-content">
    <div class="col-md-12">
      <div class="user-details">
        <div class="user-details_icon"><i class="fas fa-info"></i></div>
        <p> <span> <i class="fas fa-user-tie"></i></span> <b>Name:</b> {{ user.name }}</p>
        <p *ngIf="user.company"> <span> <i class="fas fa-industry"></i></span> <b>Company:</b> {{ user.company }}</p>
        <p> <span> <i class="fas fa-phone"></i></span> <b>Phone:</b> <a href="tel:+{{ user.phone }}"> {{
            user.phone }}</a></p>
        <p> <span> <i class="fas fa-envelope"></i></span> <b>Email:</b> <a href="mailto:{{ user.email }}"> {{
            user.email }}</a></p>
        <div *ngIf="user.company">
          <hr>
          <p *ngIf="user.company" class="button-link-wrapper">
            <button type="button" class="btn btn-primary btn-link" (click)="goToWorker(user.id)">
              go to worker
              <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
